module.exports = __webpack_public_path__ + "static/media/event-4.10da02b9.png";